import Loader from "@components/Loader";
import {
  ACCOUNT,
  LOCKSCREEN,
  LOGIN,
  MODULES,
  SECURITY,
} from "@constants/routes";
import UserContext from "@context/UserContext";
import Layout from "@pages/Layout/Layout";
import { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { TUserContext } from "types/Core/Authentication/userContext";
import Modules from "./Modules/Modules";
import Account from "./Security/Account";
import Security from "./Security/Security";

const WrappedRoutes = () => {
  const { authenticated, isInitialized, isLoading, locked } =
    useContext<TUserContext>(UserContext);

  if (!authenticated && !isInitialized) {
    return <Redirect to={LOGIN} />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (locked) {
    return <Redirect to={LOCKSCREEN} />;
  }

  return (
    <div>
      <Layout />
      <div className="container__wrap">
        <Route path={MODULES} component={Modules} />
        <Route path={SECURITY} component={Security} />
        <Route path={ACCOUNT} component={Account} />
      </div>
    </div>
  );
};

export default WrappedRoutes;
